module.exports = __webpack_public_path__ + "static/media/close.d680c9be.svg";